import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";

import {ActivatedRoute, ActivationStart, Router, RouterOutlet} from '@angular/router';
@Component({
  selector: 'app-shawarmer-tournmanets',
  templateUrl: './shawarmer-tournmanets.component.html',
  styleUrls: ['./shawarmer-tournmanets.component.css']
})

export class ShawarmerTournmanetsComponent implements OnInit  {
  cities = ['Jubail', 'Dammam', 'Abha', 'Tabouk', 'Madinah', 'Jeddah', 'Buraydah', 'Riyadh']
  currentCity;
  game;
  language: any;
  langChosen: string = 'en';

  AppSettings: any;
  constructor(public globalService: GlobalService, private router: Router, public eventService: EventsService, private activeRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe(
      param =>{
        this.currentCity = this.activeRoute.snapshot.queryParamMap.get('city')? this.activeRoute.snapshot.queryParamMap.get('city'):null
    }
    )
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });

    // set default language
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('../lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('../lang/en.json');
      }
    }
  }

  changeRoute(param) {
    this.game = param;
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('shawarmer', 1, param).subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data:[]});
      this.eventService.loadEventTournaments = false;
    })
  }

  changeCity(city: string) {
    const queryparams = {
      city:city
    }
    this.router.navigate(
      [], {queryParams:queryparams}
    );
  }

  return() {
    let url: string = this.router.url.substring(0, this.router.url.indexOf("?"));
    this.router.navigateByUrl(url);
  }
}
